import { render } from "./SprintDetails.vue?vue&type=template&id=e665075c&scoped=true"
import script from "./SprintDetails.vue?vue&type=script&lang=js"
export * from "./SprintDetails.vue?vue&type=script&lang=js"

import "./SprintDetails.vue?vue&type=style&index=0&id=e665075c&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-e665075c"

export default script